import { ErrorBoundary } from '@dixa/lib-shared-habla';
import { DashboardType } from 'lib-dashboard-types';
// eslint-disable-next-line no-restricted-imports
import { Navigate, Route, Routes, useSearchParams } from 'react-router-dom';

import { Dashboard as LegacyDashboardView } from 'components/dashboard/components/Dashboard';
import { useServerStorage } from 'utils/useServerStorage';

import { DashboardError } from './components/error/dashboardError';
import { DashboardView } from './dashboard.view';
import { ChannelDashboardView } from './views/channel';
import { QueueDashboardView } from './views/queue';

export const DashboardRoutes = (): JSX.Element => {
  const storage = useServerStorage('user');
  const { prefersNewDashboard = true } = storage.data.dashboard ?? {};

  return (
    <ErrorBoundary fallback={<DashboardError />}>
      <Routes>
        <Route path="/" element={<DashboardRedirect />} />

        <Route path="queues/*" element={<DashboardView />}>
          <Route
            index
            element={
              prefersNewDashboard ? (
                <QueueDashboardView />
              ) : (
                <LegacyDashboardView />
              )
            }
          />
        </Route>

        <Route path="channels/*" element={<ChannelDashboardView />} />

        <Route path="*" element={<Navigate to="/dashboard/queues" replace />} />
      </Routes>
    </ErrorBoundary>
  );
};

/**
 * This component handles redirecting the root '/dashboard' path to the
 * respective dashboard path based on the user's preference, ensuring that any
 * URL search params are carried along for backwards-compatibility.
 */
const DashboardRedirect = (): JSX.Element => {
  const [params] = useSearchParams();
  const storage = useServerStorage('user');
  const { defaultDashboardType = 'queue' } = storage.data.dashboard ?? {};

  const dashboardTypeToPath: Record<
    Extract<DashboardType, 'queue' | 'channel'>,
    string
  > = {
    queue: `/dashboard/queues${params.size ? `?${params.toString()}` : ''}`,
    channel: '/dashboard/channels',
  };

  return <Navigate to={dashboardTypeToPath[defaultDashboardType]} replace />;
};
